/** The most frequent value (to three decimals); the first seen on a tie. */
export const mode = (xs: readonly number[]): number | undefined => {
  const n = new Map<number, number>();
  let best: number | undefined;
  for (const x of xs) {
    const k = Math.round(x * 1000) / 1000;
    n.set(k, (n.get(k) ?? 0) + 1);
    if (best === undefined || n.get(k)! > n.get(best)!) best = k;
  }
  return best;
};
